export const APPOINTMENT_TYPES = [
  'V', 'O', 'I'
] as const;

export type AppointmentType = (typeof APPOINTMENT_TYPES)[number];

export const definition: Record<AppointmentType, { label: string; icon: string }> = {
  V: {
    icon: '',
    label: 'Vor Ort',
  },
  O: {
    icon: '',
    label: 'Online',
  },
  I: {
    icon: '',
    label: 'In-House',
  },
};

export function definitionForAppointmentType(type: AppointmentType | string): {
  label: string;
  icon: string;
} {
  const def = definition[type as AppointmentType];
  return def ?? definition['V'];
}

